import { Button, StyledTableCell, Table, TableContainer } from '../../../../components';
import { Cell, Column, Row, TableBody, TableHeader } from '@react-stately/table';
import { EmptyMessage } from './EmptyMessage';
import { useContext } from 'react';
import { Localization } from '../../../../config/localization/localization';
import { LanguageSelectorContext } from '../../../../context/LanguageSelectorContext';

import type { IUpdateVehicleResponse } from '../../../../types';
import type { FC } from 'react';

interface IVehiclesTableProps {
  onRemove: (itemId: number) => void;
  vehicles: Array<IUpdateVehicleResponse>;
}

export const VehicleTable: FC<IVehiclesTableProps> = ({ onRemove, vehicles }) => {
  const { selectedLanguage } = useContext(LanguageSelectorContext);
  const localization = new Localization(selectedLanguage);

  return (
    <TableContainer className={'w-full'}>
      <Table selectionMode={'single'}>
        {/* HEADER */}
        <TableHeader>
          <Column>
            <StyledTableCell isHeader>{localization.translate('vehicleTable.vehicleHeader')}</StyledTableCell>
          </Column>
          <Column>
            <StyledTableCell isHeader isNumeric>
              {localization.translate('vehicleTable.timeHeader')}
            </StyledTableCell>
          </Column>
          <Column>{''}</Column>
        </TableHeader>
        {/* BODY */}
        <TableBody>
          {vehicles.map((vehicle, i) => (
            <Row key={i}>
              <Cell>
                <StyledTableCell>{vehicle.title}</StyledTableCell>
              </Cell>
              <Cell>
                <StyledTableCell isNumeric>{vehicle.regular}</StyledTableCell>
              </Cell>
              <Cell>
                <StyledTableCell isNumeric>
                  <Button
                    buttonProps={{ onPress: () => onRemove(vehicle.itemId) }}
                    size={'sm'}
                    variant={'link'}
                  >
                    {localization.translate('actions.Remove')}
                  </Button>
                </StyledTableCell>
              </Cell>
            </Row>
          ))}
        </TableBody>
      </Table>

      {/* EMPTY MESSAGE */}
      {vehicles.length === 0 && (
        <EmptyMessage>{localization.translate('vehicleTable.emptyMessage')}</EmptyMessage>
      )}
    </TableContainer>
  );
};